"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.CoinPickAxeLegendaryBaseColor = exports.CoinPickAxeEpicRingColor = exports.CoinPickAxeEpicRingShape = exports.CoinPickAxeEpicBaseFlairColor = exports.CoinPickAxeEpicBaseFlairShape = exports.CoinPickAxeEpicHandleMaterial = exports.CoinPickAxeEpicGemShape = exports.CoinPickAxeEpicGemColor = exports.CoinPickAxeEpicBladeDetail = exports.CoinPickAxeEpicBladeStyle = exports.CoinPickAxeEpicBaseTopStyle = exports.CoinPickAxeEpicBaseStyle = exports.CoinPickAxeEpicBaseColor = exports.CoinPickAxeRareRingColor = exports.CoinPickAxeRareRingShape = exports.CoinPickAxeRareBaseFlairColor = exports.CoinPickAxeRareBaseFlairShape = exports.CoinPickAxeRareHandleMaterial = exports.CoinPickAxeRareGemShape = exports.CoinPickAxeRareGemColor = exports.CoinPickAxeRareBladeDetail = exports.CoinPickAxeRareBladeStyle = exports.CoinPickAxeRareBaseTopStyle = exports.CoinPickAxeRareBaseStyle = exports.CoinPickAxeRareBaseColor = exports.CoinPickAxeUncommonRingColor = exports.CoinPickAxeUncommonRingShape = exports.CoinPickAxeUncommonBaseFlairColor = exports.CoinPickAxeUncommonBaseFlairShape = exports.CoinPickAxeUncommonHandleMaterial = exports.CoinPickAxeUncommonGemShape = exports.CoinPickAxeUncommonGemColor = exports.CoinPickAxeUncommonBladeDetail = exports.CoinPickAxeUncommonBladeStyle = exports.CoinPickAxeUncommonBaseTopStyle = exports.CoinPickAxeUncommonBaseStyle = exports.CoinPickAxeUncommonBaseColor = exports.CoinPickAxeRingColor = exports.CoinPickAxeRingShape = exports.CoinPickAxeBaseFlairColor = exports.CoinPickAxeBaseFlairShape = exports.CoinPickAxeHandleMaterial = exports.CoinPickAxeGemShape = exports.CoinPickAxeGemColor = exports.CoinPickAxeBladeDetail = exports.CoinPickAxeBladeStyle = exports.CoinPickAxeBaseTopStyle = exports.CoinPickAxeBaseStyle = exports.CoinPickAxeBaseColor = exports.CoinPickAxeTier = void 0;
exports.CoinPickAxeGemColorMap = exports.CoinPickAxeValues = exports.CoinPickAxeLegendaryRingColor = exports.CoinPickAxeLegendaryRingShape = exports.CoinPickAxeLegendaryBaseFlairColor = exports.CoinPickAxeLegendaryBaseFlairShape = exports.CoinPickAxeLegendaryHandleMaterial = exports.CoinPickAxeLegendaryGemShape = exports.CoinPickAxeLegendaryGemColor = exports.CoinPickAxeLegendaryBladeDetail = exports.CoinPickAxeLegendaryBladeStyle = exports.CoinPickAxeLegendaryBaseTopStyle = exports.CoinPickAxeLegendaryBaseStyle = void 0;
var CoinPickAxeTier;
(function (CoinPickAxeTier) {
    CoinPickAxeTier[CoinPickAxeTier["Common"] = 1] = "Common";
    CoinPickAxeTier[CoinPickAxeTier["Uncommon"] = 2] = "Uncommon";
    CoinPickAxeTier[CoinPickAxeTier["Rare"] = 3] = "Rare";
    CoinPickAxeTier[CoinPickAxeTier["Epic"] = 4] = "Epic";
    CoinPickAxeTier[CoinPickAxeTier["Legendary"] = 5] = "Legendary";
})(CoinPickAxeTier = exports.CoinPickAxeTier || (exports.CoinPickAxeTier = {}));
/**
 * Common Traits
 */
var CoinPickAxeBaseColor;
(function (CoinPickAxeBaseColor) {
    CoinPickAxeBaseColor[CoinPickAxeBaseColor["Oak"] = 0] = "Oak";
    CoinPickAxeBaseColor[CoinPickAxeBaseColor["Walnut"] = 1] = "Walnut";
    CoinPickAxeBaseColor[CoinPickAxeBaseColor["Mahogany"] = 2] = "Mahogany";
})(CoinPickAxeBaseColor = exports.CoinPickAxeBaseColor || (exports.CoinPickAxeBaseColor = {}));
var CoinPickAxeBaseStyle;
(function (CoinPickAxeBaseStyle) {
    CoinPickAxeBaseStyle[CoinPickAxeBaseStyle["Old"] = 0] = "Old";
    CoinPickAxeBaseStyle[CoinPickAxeBaseStyle["New"] = 1] = "New";
    CoinPickAxeBaseStyle[CoinPickAxeBaseStyle["Refined"] = 2] = "Refined";
})(CoinPickAxeBaseStyle = exports.CoinPickAxeBaseStyle || (exports.CoinPickAxeBaseStyle = {}));
var CoinPickAxeBaseTopStyle;
(function (CoinPickAxeBaseTopStyle) {
    CoinPickAxeBaseTopStyle[CoinPickAxeBaseTopStyle["Splintered"] = 0] = "Splintered";
    CoinPickAxeBaseTopStyle[CoinPickAxeBaseTopStyle["Rounded"] = 1] = "Rounded";
    CoinPickAxeBaseTopStyle[CoinPickAxeBaseTopStyle["Pointed"] = 2] = "Pointed";
})(CoinPickAxeBaseTopStyle = exports.CoinPickAxeBaseTopStyle || (exports.CoinPickAxeBaseTopStyle = {}));
var CoinPickAxeBladeStyle;
(function (CoinPickAxeBladeStyle) {
    CoinPickAxeBladeStyle[CoinPickAxeBladeStyle["Old"] = 0] = "Old";
    CoinPickAxeBladeStyle[CoinPickAxeBladeStyle["New"] = 1] = "New";
    CoinPickAxeBladeStyle[CoinPickAxeBladeStyle["Refined"] = 2] = "Refined";
})(CoinPickAxeBladeStyle = exports.CoinPickAxeBladeStyle || (exports.CoinPickAxeBladeStyle = {}));
var CoinPickAxeBladeDetail;
(function (CoinPickAxeBladeDetail) {
    CoinPickAxeBladeDetail[CoinPickAxeBladeDetail["Squared"] = 0] = "Squared";
    CoinPickAxeBladeDetail[CoinPickAxeBladeDetail["Rounded"] = 1] = "Rounded";
    CoinPickAxeBladeDetail[CoinPickAxeBladeDetail["Pointed"] = 2] = "Pointed";
})(CoinPickAxeBladeDetail = exports.CoinPickAxeBladeDetail || (exports.CoinPickAxeBladeDetail = {}));
var CoinPickAxeGemColor;
(function (CoinPickAxeGemColor) {
    CoinPickAxeGemColor[CoinPickAxeGemColor["Ruby"] = 0] = "Ruby";
    CoinPickAxeGemColor[CoinPickAxeGemColor["Amber"] = 1] = "Amber";
    CoinPickAxeGemColor[CoinPickAxeGemColor["Citrine"] = 2] = "Citrine";
    CoinPickAxeGemColor[CoinPickAxeGemColor["Emerald"] = 3] = "Emerald";
    CoinPickAxeGemColor[CoinPickAxeGemColor["Sapphire"] = 4] = "Sapphire";
    CoinPickAxeGemColor[CoinPickAxeGemColor["Amethyst"] = 5] = "Amethyst";
    CoinPickAxeGemColor[CoinPickAxeGemColor["Quartz"] = 6] = "Quartz";
    CoinPickAxeGemColor[CoinPickAxeGemColor["Onyx"] = 7] = "Onyx";
    CoinPickAxeGemColor[CoinPickAxeGemColor["Opal"] = 8] = "Opal";
})(CoinPickAxeGemColor = exports.CoinPickAxeGemColor || (exports.CoinPickAxeGemColor = {}));
var CoinPickAxeGemShape;
(function (CoinPickAxeGemShape) {
    CoinPickAxeGemShape[CoinPickAxeGemShape["Circle"] = 0] = "Circle";
    CoinPickAxeGemShape[CoinPickAxeGemShape["Square"] = 1] = "Square";
    CoinPickAxeGemShape[CoinPickAxeGemShape["Triangle"] = 2] = "Triangle";
    CoinPickAxeGemShape[CoinPickAxeGemShape["Diamond"] = 3] = "Diamond";
    CoinPickAxeGemShape[CoinPickAxeGemShape["Oval"] = 4] = "Oval";
    CoinPickAxeGemShape[CoinPickAxeGemShape["Teardrop"] = 5] = "Teardrop";
    CoinPickAxeGemShape[CoinPickAxeGemShape["Hexagon"] = 6] = "Hexagon";
})(CoinPickAxeGemShape = exports.CoinPickAxeGemShape || (exports.CoinPickAxeGemShape = {}));
var CoinPickAxeHandleMaterial;
(function (CoinPickAxeHandleMaterial) {
    CoinPickAxeHandleMaterial[CoinPickAxeHandleMaterial["Cloth"] = 0] = "Cloth";
    CoinPickAxeHandleMaterial[CoinPickAxeHandleMaterial["Leather"] = 1] = "Leather";
    CoinPickAxeHandleMaterial[CoinPickAxeHandleMaterial["Suede"] = 2] = "Suede";
    CoinPickAxeHandleMaterial[CoinPickAxeHandleMaterial["Oak"] = 3] = "Oak";
    CoinPickAxeHandleMaterial[CoinPickAxeHandleMaterial["Walnut"] = 4] = "Walnut";
    CoinPickAxeHandleMaterial[CoinPickAxeHandleMaterial["Mahogany"] = 5] = "Mahogany";
    CoinPickAxeHandleMaterial[CoinPickAxeHandleMaterial["Iron"] = 6] = "Iron";
    CoinPickAxeHandleMaterial[CoinPickAxeHandleMaterial["Steel"] = 7] = "Steel";
    CoinPickAxeHandleMaterial[CoinPickAxeHandleMaterial["Titanium"] = 8] = "Titanium";
})(CoinPickAxeHandleMaterial = exports.CoinPickAxeHandleMaterial || (exports.CoinPickAxeHandleMaterial = {}));
var CoinPickAxeBaseFlairShape;
(function (CoinPickAxeBaseFlairShape) {
    CoinPickAxeBaseFlairShape[CoinPickAxeBaseFlairShape["Ring"] = 0] = "Ring";
    CoinPickAxeBaseFlairShape[CoinPickAxeBaseFlairShape["Square"] = 1] = "Square";
    CoinPickAxeBaseFlairShape[CoinPickAxeBaseFlairShape["Triangle"] = 2] = "Triangle";
})(CoinPickAxeBaseFlairShape = exports.CoinPickAxeBaseFlairShape || (exports.CoinPickAxeBaseFlairShape = {}));
var CoinPickAxeBaseFlairColor;
(function (CoinPickAxeBaseFlairColor) {
    CoinPickAxeBaseFlairColor[CoinPickAxeBaseFlairColor["Silver"] = 0] = "Silver";
    CoinPickAxeBaseFlairColor[CoinPickAxeBaseFlairColor["Gold"] = 1] = "Gold";
    CoinPickAxeBaseFlairColor[CoinPickAxeBaseFlairColor["Obsidian"] = 2] = "Obsidian";
})(CoinPickAxeBaseFlairColor = exports.CoinPickAxeBaseFlairColor || (exports.CoinPickAxeBaseFlairColor = {}));
var CoinPickAxeRingShape;
(function (CoinPickAxeRingShape) {
    CoinPickAxeRingShape[CoinPickAxeRingShape["Rectangle"] = 0] = "Rectangle";
    CoinPickAxeRingShape[CoinPickAxeRingShape["Semicircle"] = 1] = "Semicircle";
    CoinPickAxeRingShape[CoinPickAxeRingShape["Triangle"] = 2] = "Triangle";
})(CoinPickAxeRingShape = exports.CoinPickAxeRingShape || (exports.CoinPickAxeRingShape = {}));
var CoinPickAxeRingColor;
(function (CoinPickAxeRingColor) {
    CoinPickAxeRingColor[CoinPickAxeRingColor["Silver"] = 0] = "Silver";
    CoinPickAxeRingColor[CoinPickAxeRingColor["Gold"] = 1] = "Gold";
    CoinPickAxeRingColor[CoinPickAxeRingColor["Obsidian"] = 2] = "Obsidian";
})(CoinPickAxeRingColor = exports.CoinPickAxeRingColor || (exports.CoinPickAxeRingColor = {}));
/**
 * Uncommon Traits
 */
var CoinPickAxeUncommonBaseColor;
(function (CoinPickAxeUncommonBaseColor) {
    CoinPickAxeUncommonBaseColor[CoinPickAxeUncommonBaseColor["Silver"] = 0] = "Silver";
})(CoinPickAxeUncommonBaseColor = exports.CoinPickAxeUncommonBaseColor || (exports.CoinPickAxeUncommonBaseColor = {}));
var CoinPickAxeUncommonBaseStyle;
(function (CoinPickAxeUncommonBaseStyle) {
    CoinPickAxeUncommonBaseStyle[CoinPickAxeUncommonBaseStyle["Old"] = 0] = "Old";
    CoinPickAxeUncommonBaseStyle[CoinPickAxeUncommonBaseStyle["New"] = 1] = "New";
    CoinPickAxeUncommonBaseStyle[CoinPickAxeUncommonBaseStyle["Refined"] = 2] = "Refined";
})(CoinPickAxeUncommonBaseStyle = exports.CoinPickAxeUncommonBaseStyle || (exports.CoinPickAxeUncommonBaseStyle = {}));
var CoinPickAxeUncommonBaseTopStyle;
(function (CoinPickAxeUncommonBaseTopStyle) {
    CoinPickAxeUncommonBaseTopStyle[CoinPickAxeUncommonBaseTopStyle["Splintered"] = 0] = "Splintered";
    CoinPickAxeUncommonBaseTopStyle[CoinPickAxeUncommonBaseTopStyle["Rounded"] = 1] = "Rounded";
    CoinPickAxeUncommonBaseTopStyle[CoinPickAxeUncommonBaseTopStyle["Pointed"] = 2] = "Pointed";
})(CoinPickAxeUncommonBaseTopStyle = exports.CoinPickAxeUncommonBaseTopStyle || (exports.CoinPickAxeUncommonBaseTopStyle = {}));
var CoinPickAxeUncommonBladeStyle;
(function (CoinPickAxeUncommonBladeStyle) {
    CoinPickAxeUncommonBladeStyle[CoinPickAxeUncommonBladeStyle["Old"] = 0] = "Old";
    CoinPickAxeUncommonBladeStyle[CoinPickAxeUncommonBladeStyle["New"] = 1] = "New";
    CoinPickAxeUncommonBladeStyle[CoinPickAxeUncommonBladeStyle["Refined"] = 2] = "Refined";
})(CoinPickAxeUncommonBladeStyle = exports.CoinPickAxeUncommonBladeStyle || (exports.CoinPickAxeUncommonBladeStyle = {}));
var CoinPickAxeUncommonBladeDetail;
(function (CoinPickAxeUncommonBladeDetail) {
    CoinPickAxeUncommonBladeDetail[CoinPickAxeUncommonBladeDetail["Squared"] = 0] = "Squared";
    CoinPickAxeUncommonBladeDetail[CoinPickAxeUncommonBladeDetail["Rounded"] = 1] = "Rounded";
    CoinPickAxeUncommonBladeDetail[CoinPickAxeUncommonBladeDetail["Pointed"] = 2] = "Pointed";
})(CoinPickAxeUncommonBladeDetail = exports.CoinPickAxeUncommonBladeDetail || (exports.CoinPickAxeUncommonBladeDetail = {}));
var CoinPickAxeUncommonGemColor;
(function (CoinPickAxeUncommonGemColor) {
    CoinPickAxeUncommonGemColor[CoinPickAxeUncommonGemColor["Ruby"] = 0] = "Ruby";
    CoinPickAxeUncommonGemColor[CoinPickAxeUncommonGemColor["Amber"] = 1] = "Amber";
    CoinPickAxeUncommonGemColor[CoinPickAxeUncommonGemColor["Citrine"] = 2] = "Citrine";
    CoinPickAxeUncommonGemColor[CoinPickAxeUncommonGemColor["Emerald"] = 3] = "Emerald";
    CoinPickAxeUncommonGemColor[CoinPickAxeUncommonGemColor["Sapphire"] = 4] = "Sapphire";
    CoinPickAxeUncommonGemColor[CoinPickAxeUncommonGemColor["Amethyst"] = 5] = "Amethyst";
    CoinPickAxeUncommonGemColor[CoinPickAxeUncommonGemColor["Quartz"] = 6] = "Quartz";
    CoinPickAxeUncommonGemColor[CoinPickAxeUncommonGemColor["Onyx"] = 7] = "Onyx";
    CoinPickAxeUncommonGemColor[CoinPickAxeUncommonGemColor["Opal"] = 8] = "Opal";
})(CoinPickAxeUncommonGemColor = exports.CoinPickAxeUncommonGemColor || (exports.CoinPickAxeUncommonGemColor = {}));
var CoinPickAxeUncommonGemShape;
(function (CoinPickAxeUncommonGemShape) {
    CoinPickAxeUncommonGemShape[CoinPickAxeUncommonGemShape["Circle"] = 0] = "Circle";
    CoinPickAxeUncommonGemShape[CoinPickAxeUncommonGemShape["Square"] = 1] = "Square";
    CoinPickAxeUncommonGemShape[CoinPickAxeUncommonGemShape["Triangle"] = 2] = "Triangle";
    CoinPickAxeUncommonGemShape[CoinPickAxeUncommonGemShape["Diamond"] = 3] = "Diamond";
    CoinPickAxeUncommonGemShape[CoinPickAxeUncommonGemShape["Oval"] = 4] = "Oval";
    CoinPickAxeUncommonGemShape[CoinPickAxeUncommonGemShape["Teardrop"] = 5] = "Teardrop";
    CoinPickAxeUncommonGemShape[CoinPickAxeUncommonGemShape["Hexagon"] = 6] = "Hexagon";
})(CoinPickAxeUncommonGemShape = exports.CoinPickAxeUncommonGemShape || (exports.CoinPickAxeUncommonGemShape = {}));
var CoinPickAxeUncommonHandleMaterial;
(function (CoinPickAxeUncommonHandleMaterial) {
    CoinPickAxeUncommonHandleMaterial[CoinPickAxeUncommonHandleMaterial["Britannia"] = 0] = "Britannia";
    CoinPickAxeUncommonHandleMaterial[CoinPickAxeUncommonHandleMaterial["Sterling"] = 1] = "Sterling";
    CoinPickAxeUncommonHandleMaterial[CoinPickAxeUncommonHandleMaterial["Argentium"] = 2] = "Argentium";
})(CoinPickAxeUncommonHandleMaterial = exports.CoinPickAxeUncommonHandleMaterial || (exports.CoinPickAxeUncommonHandleMaterial = {}));
var CoinPickAxeUncommonBaseFlairShape;
(function (CoinPickAxeUncommonBaseFlairShape) {
    CoinPickAxeUncommonBaseFlairShape[CoinPickAxeUncommonBaseFlairShape["Ring"] = 0] = "Ring";
    CoinPickAxeUncommonBaseFlairShape[CoinPickAxeUncommonBaseFlairShape["Square"] = 1] = "Square";
    CoinPickAxeUncommonBaseFlairShape[CoinPickAxeUncommonBaseFlairShape["Triangle"] = 2] = "Triangle";
})(CoinPickAxeUncommonBaseFlairShape = exports.CoinPickAxeUncommonBaseFlairShape || (exports.CoinPickAxeUncommonBaseFlairShape = {}));
var CoinPickAxeUncommonBaseFlairColor;
(function (CoinPickAxeUncommonBaseFlairColor) {
    CoinPickAxeUncommonBaseFlairColor[CoinPickAxeUncommonBaseFlairColor["Silver"] = 0] = "Silver";
})(CoinPickAxeUncommonBaseFlairColor = exports.CoinPickAxeUncommonBaseFlairColor || (exports.CoinPickAxeUncommonBaseFlairColor = {}));
var CoinPickAxeUncommonRingShape;
(function (CoinPickAxeUncommonRingShape) {
    CoinPickAxeUncommonRingShape[CoinPickAxeUncommonRingShape["Rectangle"] = 0] = "Rectangle";
    CoinPickAxeUncommonRingShape[CoinPickAxeUncommonRingShape["Semicircle"] = 1] = "Semicircle";
    CoinPickAxeUncommonRingShape[CoinPickAxeUncommonRingShape["Triangle"] = 2] = "Triangle";
})(CoinPickAxeUncommonRingShape = exports.CoinPickAxeUncommonRingShape || (exports.CoinPickAxeUncommonRingShape = {}));
var CoinPickAxeUncommonRingColor;
(function (CoinPickAxeUncommonRingColor) {
    CoinPickAxeUncommonRingColor[CoinPickAxeUncommonRingColor["Silver"] = 0] = "Silver";
})(CoinPickAxeUncommonRingColor = exports.CoinPickAxeUncommonRingColor || (exports.CoinPickAxeUncommonRingColor = {}));
/**
 * Rare Traits
 */
var CoinPickAxeRareBaseColor;
(function (CoinPickAxeRareBaseColor) {
    CoinPickAxeRareBaseColor[CoinPickAxeRareBaseColor["Gold"] = 0] = "Gold";
})(CoinPickAxeRareBaseColor = exports.CoinPickAxeRareBaseColor || (exports.CoinPickAxeRareBaseColor = {}));
var CoinPickAxeRareBaseStyle;
(function (CoinPickAxeRareBaseStyle) {
    CoinPickAxeRareBaseStyle[CoinPickAxeRareBaseStyle["Old"] = 0] = "Old";
    CoinPickAxeRareBaseStyle[CoinPickAxeRareBaseStyle["New"] = 1] = "New";
    CoinPickAxeRareBaseStyle[CoinPickAxeRareBaseStyle["Refined"] = 2] = "Refined";
})(CoinPickAxeRareBaseStyle = exports.CoinPickAxeRareBaseStyle || (exports.CoinPickAxeRareBaseStyle = {}));
var CoinPickAxeRareBaseTopStyle;
(function (CoinPickAxeRareBaseTopStyle) {
    CoinPickAxeRareBaseTopStyle[CoinPickAxeRareBaseTopStyle["Rounded"] = 0] = "Rounded";
    CoinPickAxeRareBaseTopStyle[CoinPickAxeRareBaseTopStyle["Pointed"] = 1] = "Pointed";
})(CoinPickAxeRareBaseTopStyle = exports.CoinPickAxeRareBaseTopStyle || (exports.CoinPickAxeRareBaseTopStyle = {}));
var CoinPickAxeRareBladeStyle;
(function (CoinPickAxeRareBladeStyle) {
    CoinPickAxeRareBladeStyle[CoinPickAxeRareBladeStyle["Old"] = 0] = "Old";
    CoinPickAxeRareBladeStyle[CoinPickAxeRareBladeStyle["New"] = 1] = "New";
    CoinPickAxeRareBladeStyle[CoinPickAxeRareBladeStyle["Refined"] = 2] = "Refined";
})(CoinPickAxeRareBladeStyle = exports.CoinPickAxeRareBladeStyle || (exports.CoinPickAxeRareBladeStyle = {}));
var CoinPickAxeRareBladeDetail;
(function (CoinPickAxeRareBladeDetail) {
    CoinPickAxeRareBladeDetail[CoinPickAxeRareBladeDetail["Squared"] = 0] = "Squared";
    CoinPickAxeRareBladeDetail[CoinPickAxeRareBladeDetail["Rounded"] = 1] = "Rounded";
    CoinPickAxeRareBladeDetail[CoinPickAxeRareBladeDetail["Pointed"] = 2] = "Pointed";
})(CoinPickAxeRareBladeDetail = exports.CoinPickAxeRareBladeDetail || (exports.CoinPickAxeRareBladeDetail = {}));
var CoinPickAxeRareGemColor;
(function (CoinPickAxeRareGemColor) {
    CoinPickAxeRareGemColor[CoinPickAxeRareGemColor["Ruby"] = 0] = "Ruby";
    CoinPickAxeRareGemColor[CoinPickAxeRareGemColor["Amber"] = 1] = "Amber";
    CoinPickAxeRareGemColor[CoinPickAxeRareGemColor["Quartz"] = 2] = "Quartz";
    CoinPickAxeRareGemColor[CoinPickAxeRareGemColor["Onyx"] = 3] = "Onyx";
    CoinPickAxeRareGemColor[CoinPickAxeRareGemColor["Opal"] = 4] = "Opal";
})(CoinPickAxeRareGemColor = exports.CoinPickAxeRareGemColor || (exports.CoinPickAxeRareGemColor = {}));
var CoinPickAxeRareGemShape;
(function (CoinPickAxeRareGemShape) {
    CoinPickAxeRareGemShape[CoinPickAxeRareGemShape["Triangle"] = 0] = "Triangle";
    CoinPickAxeRareGemShape[CoinPickAxeRareGemShape["Diamond"] = 1] = "Diamond";
    CoinPickAxeRareGemShape[CoinPickAxeRareGemShape["Oval"] = 2] = "Oval";
    CoinPickAxeRareGemShape[CoinPickAxeRareGemShape["Teardrop"] = 3] = "Teardrop";
    CoinPickAxeRareGemShape[CoinPickAxeRareGemShape["Hexagon"] = 4] = "Hexagon";
})(CoinPickAxeRareGemShape = exports.CoinPickAxeRareGemShape || (exports.CoinPickAxeRareGemShape = {}));
var CoinPickAxeRareHandleMaterial;
(function (CoinPickAxeRareHandleMaterial) {
    CoinPickAxeRareHandleMaterial[CoinPickAxeRareHandleMaterial["Gold"] = 0] = "Gold";
})(CoinPickAxeRareHandleMaterial = exports.CoinPickAxeRareHandleMaterial || (exports.CoinPickAxeRareHandleMaterial = {}));
var CoinPickAxeRareBaseFlairShape;
(function (CoinPickAxeRareBaseFlairShape) {
    CoinPickAxeRareBaseFlairShape[CoinPickAxeRareBaseFlairShape["Ring"] = 0] = "Ring";
    CoinPickAxeRareBaseFlairShape[CoinPickAxeRareBaseFlairShape["Square"] = 1] = "Square";
    CoinPickAxeRareBaseFlairShape[CoinPickAxeRareBaseFlairShape["Triangle"] = 2] = "Triangle";
})(CoinPickAxeRareBaseFlairShape = exports.CoinPickAxeRareBaseFlairShape || (exports.CoinPickAxeRareBaseFlairShape = {}));
var CoinPickAxeRareBaseFlairColor;
(function (CoinPickAxeRareBaseFlairColor) {
    CoinPickAxeRareBaseFlairColor[CoinPickAxeRareBaseFlairColor["Gold"] = 0] = "Gold";
})(CoinPickAxeRareBaseFlairColor = exports.CoinPickAxeRareBaseFlairColor || (exports.CoinPickAxeRareBaseFlairColor = {}));
var CoinPickAxeRareRingShape;
(function (CoinPickAxeRareRingShape) {
    CoinPickAxeRareRingShape[CoinPickAxeRareRingShape["Rectangle"] = 0] = "Rectangle";
    CoinPickAxeRareRingShape[CoinPickAxeRareRingShape["Semicircle"] = 1] = "Semicircle";
    CoinPickAxeRareRingShape[CoinPickAxeRareRingShape["Triangle"] = 2] = "Triangle";
})(CoinPickAxeRareRingShape = exports.CoinPickAxeRareRingShape || (exports.CoinPickAxeRareRingShape = {}));
var CoinPickAxeRareRingColor;
(function (CoinPickAxeRareRingColor) {
    CoinPickAxeRareRingColor[CoinPickAxeRareRingColor["Gold"] = 0] = "Gold";
})(CoinPickAxeRareRingColor = exports.CoinPickAxeRareRingColor || (exports.CoinPickAxeRareRingColor = {}));
/**
 * Epic Traits
 */
var CoinPickAxeEpicBaseColor;
(function (CoinPickAxeEpicBaseColor) {
    CoinPickAxeEpicBaseColor[CoinPickAxeEpicBaseColor["Obsidian"] = 0] = "Obsidian";
})(CoinPickAxeEpicBaseColor = exports.CoinPickAxeEpicBaseColor || (exports.CoinPickAxeEpicBaseColor = {}));
var CoinPickAxeEpicBaseStyle;
(function (CoinPickAxeEpicBaseStyle) {
    CoinPickAxeEpicBaseStyle[CoinPickAxeEpicBaseStyle["Old"] = 0] = "Old";
    CoinPickAxeEpicBaseStyle[CoinPickAxeEpicBaseStyle["Refined"] = 1] = "Refined";
})(CoinPickAxeEpicBaseStyle = exports.CoinPickAxeEpicBaseStyle || (exports.CoinPickAxeEpicBaseStyle = {}));
var CoinPickAxeEpicBaseTopStyle;
(function (CoinPickAxeEpicBaseTopStyle) {
    CoinPickAxeEpicBaseTopStyle[CoinPickAxeEpicBaseTopStyle["Rounded"] = 0] = "Rounded";
    CoinPickAxeEpicBaseTopStyle[CoinPickAxeEpicBaseTopStyle["Pointed"] = 1] = "Pointed";
})(CoinPickAxeEpicBaseTopStyle = exports.CoinPickAxeEpicBaseTopStyle || (exports.CoinPickAxeEpicBaseTopStyle = {}));
var CoinPickAxeEpicBladeStyle;
(function (CoinPickAxeEpicBladeStyle) {
    CoinPickAxeEpicBladeStyle[CoinPickAxeEpicBladeStyle["Old"] = 0] = "Old";
    CoinPickAxeEpicBladeStyle[CoinPickAxeEpicBladeStyle["New"] = 1] = "New";
    CoinPickAxeEpicBladeStyle[CoinPickAxeEpicBladeStyle["Refined"] = 2] = "Refined";
})(CoinPickAxeEpicBladeStyle = exports.CoinPickAxeEpicBladeStyle || (exports.CoinPickAxeEpicBladeStyle = {}));
var CoinPickAxeEpicBladeDetail;
(function (CoinPickAxeEpicBladeDetail) {
    CoinPickAxeEpicBladeDetail[CoinPickAxeEpicBladeDetail["Rounded"] = 0] = "Rounded";
    CoinPickAxeEpicBladeDetail[CoinPickAxeEpicBladeDetail["Pointed"] = 1] = "Pointed";
})(CoinPickAxeEpicBladeDetail = exports.CoinPickAxeEpicBladeDetail || (exports.CoinPickAxeEpicBladeDetail = {}));
var CoinPickAxeEpicGemColor;
(function (CoinPickAxeEpicGemColor) {
    CoinPickAxeEpicGemColor[CoinPickAxeEpicGemColor["Ruby"] = 0] = "Ruby";
    CoinPickAxeEpicGemColor[CoinPickAxeEpicGemColor["Emerald"] = 1] = "Emerald";
    CoinPickAxeEpicGemColor[CoinPickAxeEpicGemColor["Amethyst"] = 2] = "Amethyst";
    CoinPickAxeEpicGemColor[CoinPickAxeEpicGemColor["Opal"] = 3] = "Opal";
})(CoinPickAxeEpicGemColor = exports.CoinPickAxeEpicGemColor || (exports.CoinPickAxeEpicGemColor = {}));
var CoinPickAxeEpicGemShape;
(function (CoinPickAxeEpicGemShape) {
    CoinPickAxeEpicGemShape[CoinPickAxeEpicGemShape["Triangle"] = 0] = "Triangle";
    CoinPickAxeEpicGemShape[CoinPickAxeEpicGemShape["Oval"] = 1] = "Oval";
    CoinPickAxeEpicGemShape[CoinPickAxeEpicGemShape["Teardrop"] = 2] = "Teardrop";
    CoinPickAxeEpicGemShape[CoinPickAxeEpicGemShape["Hexagon"] = 3] = "Hexagon";
})(CoinPickAxeEpicGemShape = exports.CoinPickAxeEpicGemShape || (exports.CoinPickAxeEpicGemShape = {}));
var CoinPickAxeEpicHandleMaterial;
(function (CoinPickAxeEpicHandleMaterial) {
    CoinPickAxeEpicHandleMaterial[CoinPickAxeEpicHandleMaterial["Obsidian"] = 0] = "Obsidian";
})(CoinPickAxeEpicHandleMaterial = exports.CoinPickAxeEpicHandleMaterial || (exports.CoinPickAxeEpicHandleMaterial = {}));
var CoinPickAxeEpicBaseFlairShape;
(function (CoinPickAxeEpicBaseFlairShape) {
    CoinPickAxeEpicBaseFlairShape[CoinPickAxeEpicBaseFlairShape["Square"] = 0] = "Square";
    CoinPickAxeEpicBaseFlairShape[CoinPickAxeEpicBaseFlairShape["Triangle"] = 1] = "Triangle";
})(CoinPickAxeEpicBaseFlairShape = exports.CoinPickAxeEpicBaseFlairShape || (exports.CoinPickAxeEpicBaseFlairShape = {}));
var CoinPickAxeEpicBaseFlairColor;
(function (CoinPickAxeEpicBaseFlairColor) {
    CoinPickAxeEpicBaseFlairColor[CoinPickAxeEpicBaseFlairColor["Obsidian"] = 0] = "Obsidian";
})(CoinPickAxeEpicBaseFlairColor = exports.CoinPickAxeEpicBaseFlairColor || (exports.CoinPickAxeEpicBaseFlairColor = {}));
var CoinPickAxeEpicRingShape;
(function (CoinPickAxeEpicRingShape) {
    CoinPickAxeEpicRingShape[CoinPickAxeEpicRingShape["Semicircle"] = 0] = "Semicircle";
    CoinPickAxeEpicRingShape[CoinPickAxeEpicRingShape["Triangle"] = 1] = "Triangle";
})(CoinPickAxeEpicRingShape = exports.CoinPickAxeEpicRingShape || (exports.CoinPickAxeEpicRingShape = {}));
var CoinPickAxeEpicRingColor;
(function (CoinPickAxeEpicRingColor) {
    CoinPickAxeEpicRingColor[CoinPickAxeEpicRingColor["Obsidian"] = 0] = "Obsidian";
})(CoinPickAxeEpicRingColor = exports.CoinPickAxeEpicRingColor || (exports.CoinPickAxeEpicRingColor = {}));
/**
 * Legendary Traits
 */
var CoinPickAxeLegendaryBaseColor;
(function (CoinPickAxeLegendaryBaseColor) {
    CoinPickAxeLegendaryBaseColor[CoinPickAxeLegendaryBaseColor["Diamond"] = 0] = "Diamond";
})(CoinPickAxeLegendaryBaseColor = exports.CoinPickAxeLegendaryBaseColor || (exports.CoinPickAxeLegendaryBaseColor = {}));
var CoinPickAxeLegendaryBaseStyle;
(function (CoinPickAxeLegendaryBaseStyle) {
    CoinPickAxeLegendaryBaseStyle[CoinPickAxeLegendaryBaseStyle["Old"] = 0] = "Old";
    CoinPickAxeLegendaryBaseStyle[CoinPickAxeLegendaryBaseStyle["Refined"] = 1] = "Refined";
})(CoinPickAxeLegendaryBaseStyle = exports.CoinPickAxeLegendaryBaseStyle || (exports.CoinPickAxeLegendaryBaseStyle = {}));
var CoinPickAxeLegendaryBaseTopStyle;
(function (CoinPickAxeLegendaryBaseTopStyle) {
    CoinPickAxeLegendaryBaseTopStyle[CoinPickAxeLegendaryBaseTopStyle["Rounded"] = 0] = "Rounded";
    CoinPickAxeLegendaryBaseTopStyle[CoinPickAxeLegendaryBaseTopStyle["Pointed"] = 1] = "Pointed";
})(CoinPickAxeLegendaryBaseTopStyle = exports.CoinPickAxeLegendaryBaseTopStyle || (exports.CoinPickAxeLegendaryBaseTopStyle = {}));
var CoinPickAxeLegendaryBladeStyle;
(function (CoinPickAxeLegendaryBladeStyle) {
    CoinPickAxeLegendaryBladeStyle[CoinPickAxeLegendaryBladeStyle["Old"] = 0] = "Old";
    CoinPickAxeLegendaryBladeStyle[CoinPickAxeLegendaryBladeStyle["Refined"] = 1] = "Refined";
})(CoinPickAxeLegendaryBladeStyle = exports.CoinPickAxeLegendaryBladeStyle || (exports.CoinPickAxeLegendaryBladeStyle = {}));
var CoinPickAxeLegendaryBladeDetail;
(function (CoinPickAxeLegendaryBladeDetail) {
    CoinPickAxeLegendaryBladeDetail[CoinPickAxeLegendaryBladeDetail["Pointed"] = 0] = "Pointed";
})(CoinPickAxeLegendaryBladeDetail = exports.CoinPickAxeLegendaryBladeDetail || (exports.CoinPickAxeLegendaryBladeDetail = {}));
var CoinPickAxeLegendaryGemColor;
(function (CoinPickAxeLegendaryGemColor) {
    CoinPickAxeLegendaryGemColor[CoinPickAxeLegendaryGemColor["Quartz"] = 0] = "Quartz";
    CoinPickAxeLegendaryGemColor[CoinPickAxeLegendaryGemColor["Onyx"] = 1] = "Onyx";
    CoinPickAxeLegendaryGemColor[CoinPickAxeLegendaryGemColor["Opal"] = 2] = "Opal";
})(CoinPickAxeLegendaryGemColor = exports.CoinPickAxeLegendaryGemColor || (exports.CoinPickAxeLegendaryGemColor = {}));
var CoinPickAxeLegendaryGemShape;
(function (CoinPickAxeLegendaryGemShape) {
    CoinPickAxeLegendaryGemShape[CoinPickAxeLegendaryGemShape["Diamond"] = 0] = "Diamond";
    CoinPickAxeLegendaryGemShape[CoinPickAxeLegendaryGemShape["Oval"] = 1] = "Oval";
    CoinPickAxeLegendaryGemShape[CoinPickAxeLegendaryGemShape["Hexagon"] = 2] = "Hexagon";
})(CoinPickAxeLegendaryGemShape = exports.CoinPickAxeLegendaryGemShape || (exports.CoinPickAxeLegendaryGemShape = {}));
var CoinPickAxeLegendaryHandleMaterial;
(function (CoinPickAxeLegendaryHandleMaterial) {
    CoinPickAxeLegendaryHandleMaterial[CoinPickAxeLegendaryHandleMaterial["Diamond"] = 0] = "Diamond";
})(CoinPickAxeLegendaryHandleMaterial = exports.CoinPickAxeLegendaryHandleMaterial || (exports.CoinPickAxeLegendaryHandleMaterial = {}));
var CoinPickAxeLegendaryBaseFlairShape;
(function (CoinPickAxeLegendaryBaseFlairShape) {
    CoinPickAxeLegendaryBaseFlairShape[CoinPickAxeLegendaryBaseFlairShape["Square"] = 0] = "Square";
    CoinPickAxeLegendaryBaseFlairShape[CoinPickAxeLegendaryBaseFlairShape["Triangle"] = 1] = "Triangle";
})(CoinPickAxeLegendaryBaseFlairShape = exports.CoinPickAxeLegendaryBaseFlairShape || (exports.CoinPickAxeLegendaryBaseFlairShape = {}));
var CoinPickAxeLegendaryBaseFlairColor;
(function (CoinPickAxeLegendaryBaseFlairColor) {
    CoinPickAxeLegendaryBaseFlairColor[CoinPickAxeLegendaryBaseFlairColor["Diamond"] = 0] = "Diamond";
})(CoinPickAxeLegendaryBaseFlairColor = exports.CoinPickAxeLegendaryBaseFlairColor || (exports.CoinPickAxeLegendaryBaseFlairColor = {}));
var CoinPickAxeLegendaryRingShape;
(function (CoinPickAxeLegendaryRingShape) {
    CoinPickAxeLegendaryRingShape[CoinPickAxeLegendaryRingShape["Triangle"] = 0] = "Triangle";
})(CoinPickAxeLegendaryRingShape = exports.CoinPickAxeLegendaryRingShape || (exports.CoinPickAxeLegendaryRingShape = {}));
var CoinPickAxeLegendaryRingColor;
(function (CoinPickAxeLegendaryRingColor) {
    CoinPickAxeLegendaryRingColor[CoinPickAxeLegendaryRingColor["Diamond"] = 0] = "Diamond";
})(CoinPickAxeLegendaryRingColor = exports.CoinPickAxeLegendaryRingColor || (exports.CoinPickAxeLegendaryRingColor = {}));
/**
 * Pick Axe
 */
exports.CoinPickAxeValues = {
    BaseColor: {
        Common: CoinPickAxeBaseColor,
        Uncommon: CoinPickAxeUncommonBaseColor,
        Rare: CoinPickAxeRareBaseColor,
        Epic: CoinPickAxeEpicBaseColor,
        Legendary: CoinPickAxeLegendaryBaseColor,
    },
    BaseStyle: {
        Common: CoinPickAxeBaseStyle,
        Uncommon: CoinPickAxeUncommonBaseStyle,
        Rare: CoinPickAxeRareBaseStyle,
        Epic: CoinPickAxeEpicBaseStyle,
        Legendary: CoinPickAxeLegendaryBaseStyle,
    },
    BaseTopStyle: {
        Common: CoinPickAxeBaseTopStyle,
        Uncommon: CoinPickAxeUncommonBaseTopStyle,
        Rare: CoinPickAxeRareBaseTopStyle,
        Epic: CoinPickAxeEpicBaseTopStyle,
        Legendary: CoinPickAxeLegendaryBaseTopStyle,
    },
    BladeStyle: {
        Common: CoinPickAxeBladeStyle,
        Uncommon: CoinPickAxeUncommonBladeStyle,
        Rare: CoinPickAxeRareBladeStyle,
        Epic: CoinPickAxeEpicBladeStyle,
        Legendary: CoinPickAxeLegendaryBladeStyle,
    },
    BladeDetail: {
        Common: CoinPickAxeBladeDetail,
        Uncommon: CoinPickAxeUncommonBladeDetail,
        Rare: CoinPickAxeRareBladeDetail,
        Epic: CoinPickAxeEpicBladeDetail,
        Legendary: CoinPickAxeLegendaryBladeDetail,
    },
    GemColor: {
        Common: CoinPickAxeGemColor,
        Uncommon: CoinPickAxeUncommonGemColor,
        Rare: CoinPickAxeRareGemColor,
        Epic: CoinPickAxeEpicGemColor,
        Legendary: CoinPickAxeLegendaryGemColor,
    },
    GemShape: {
        Common: CoinPickAxeGemShape,
        Uncommon: CoinPickAxeUncommonGemShape,
        Rare: CoinPickAxeRareGemShape,
        Epic: CoinPickAxeEpicGemShape,
        Legendary: CoinPickAxeLegendaryGemShape,
    },
    HandleMaterial: {
        Common: CoinPickAxeHandleMaterial,
        Uncommon: CoinPickAxeUncommonHandleMaterial,
        Rare: CoinPickAxeRareHandleMaterial,
        Epic: CoinPickAxeEpicHandleMaterial,
        Legendary: CoinPickAxeLegendaryHandleMaterial,
    },
    BaseFlairShape: {
        Common: CoinPickAxeBaseFlairShape,
        Uncommon: CoinPickAxeUncommonBaseFlairShape,
        Rare: CoinPickAxeRareBaseFlairShape,
        Epic: CoinPickAxeEpicBaseFlairShape,
        Legendary: CoinPickAxeLegendaryBaseFlairShape,
    },
    BaseFlairColor: {
        Common: CoinPickAxeBaseFlairColor,
        Uncommon: CoinPickAxeUncommonBaseFlairColor,
        Rare: CoinPickAxeRareBaseFlairColor,
        Epic: CoinPickAxeEpicBaseFlairColor,
        Legendary: CoinPickAxeLegendaryBaseFlairColor,
    },
    RingShape: {
        Common: CoinPickAxeRingShape,
        Uncommon: CoinPickAxeUncommonRingShape,
        Rare: CoinPickAxeRareRingShape,
        Epic: CoinPickAxeEpicRingShape,
        Legendary: CoinPickAxeLegendaryRingShape,
    },
    RingColor: {
        Common: CoinPickAxeRingColor,
        Uncommon: CoinPickAxeUncommonRingColor,
        Rare: CoinPickAxeRareRingColor,
        Epic: CoinPickAxeEpicRingColor,
        Legendary: CoinPickAxeLegendaryRingColor,
    },
};
var CoinPickAxeGemColorMap;
(function (CoinPickAxeGemColorMap) {
    CoinPickAxeGemColorMap[CoinPickAxeGemColorMap["Red"] = 0] = "Red";
    CoinPickAxeGemColorMap[CoinPickAxeGemColorMap["Green"] = 3] = "Green";
    CoinPickAxeGemColorMap[CoinPickAxeGemColorMap["Blue"] = 4] = "Blue";
    CoinPickAxeGemColorMap[CoinPickAxeGemColorMap["Orange"] = 1] = "Orange";
    CoinPickAxeGemColorMap[CoinPickAxeGemColorMap["Yellow"] = 2] = "Yellow";
    CoinPickAxeGemColorMap[CoinPickAxeGemColorMap["Purple"] = 5] = "Purple";
    CoinPickAxeGemColorMap[CoinPickAxeGemColorMap["White"] = 6] = "White";
    CoinPickAxeGemColorMap[CoinPickAxeGemColorMap["Black"] = 7] = "Black";
    CoinPickAxeGemColorMap[CoinPickAxeGemColorMap["Rainbow"] = 8] = "Rainbow";
})(CoinPickAxeGemColorMap = exports.CoinPickAxeGemColorMap || (exports.CoinPickAxeGemColorMap = {}));
//# sourceMappingURL=types.js.map